import { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import 'highcharts/modules/no-data-to-display'
import StyledHighcharts, { tooltipStyle } from './StyledHighcharts'
import { useTranslation } from 'react-i18next'

const BasicBar = ({ data }) => {
  const { t } = useTranslation()
  const chartRef = useRef(null)

  const [chartOptions, setChartOptions] = useState({
    colors: ['#0A91CB'],

    chart: {
      type: 'bar',
    },

    lang: {
      noData:
        '<div style="text-align: center; position: relative;">' +
          '<i class="icon-chart-nodata -nohover" style="margin-bottom: 16px;"></i><br>' +
          t('common.noChartData') +
        '</div>',
    },
    noData: {
      style: {
        fontWeight: 'normal',
        fontSize: '12px',
        fontFamily: 'Open Sans',
      },
      useHTML: true,
    },
    title: {
      text: null,
    },

    xAxis: {
      lineColor: '#F1F1F1',
      tickLength: 0,
      title: null,
      showEmpty: false,
      type: 'category',
      labels: {
        x: -7,
      },
    },

    yAxis: {
      enabled: false,
      title: { text: null },
      visible: false,
    },

    tooltip: {
      ...tooltipStyle,
      headerFormat: '<span style="color:{point.color}">\u25CF</span> {point.key}: {point.y} ',
      pointFormat: '',
      outside: true,
    },

    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: '{point.y}',
        },
      },
      series: {
        pointPadding: 0,
        maxPointWidth: 50,
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    accessibility: {
      enabled: false,
    },
  })

  useEffect(() => {
    updateSeries()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const chart = chartRef.current?.chart
    updateSeries()
    chart?.reflow()
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  const updateSeries = () => {
    const series = data.map(entry => ({
      y: entry.value,
      name: entry.name,
      color: entry.color || '#0A91CB',
    }))

    setChartOptions({
      ...chartOptions,
      ...{
        series: [{ data: series }],
      },
    })
  }

  return (
    <StyledHighcharts
      highcharts={Highcharts}
      options={chartOptions}
      forwardRef={chartRef}
    />
  )
}

BasicBar.propTypes = {
  data: PropTypes.array,
}

export default BasicBar
